// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hg-0";
export var assigneeDetails = "_hg-1";
export var assigneeInfo = "_hg-2";
export var dropdownContainer = "_hg-4";
export var dropdownImage = "_hg-5";
export var editAssigneeInfo = "_hg-3";
export var editAssigneeModalContainer = "_hg-6";
export var hidden = "_hg-8";
export var input = "_hg-7";